import React from 'react';

import { bemCssModules, getTestId } from '@utils';

import Button from '@components/Button';

import style from './InfoContent.scss';

const cn = bemCssModules(style, 'InfoContent');
const ti = getTestId('InfoContent');

export type InfoContentType = {
  onClickButton?: () => void;
  onClickLink?: () => void;
  linkText?: string;
  title?: string;
  description?: string | React.ReactNode;
  buttonText?: string;
  isLoading?: boolean;
};

export const InfoContent: CustomFC<InfoContentType> = props => {
  const {
    className,
    children,
    title,
    description = '',
    buttonText,
    linkText,
    onClickButton,
    onClickLink,
    isLoading,
  } = props;

  return (
    <div className={cn(null, [className])} data-testid={ti()}>
      {children}
      <div className={cn('content')}>
        <h1 className={cn('title')}>{title}</h1>
        <p className={cn('description')}>{description}</p>
        {buttonText && (
          <div>
            <Button onClick={onClickButton} isLoading={isLoading} className={cn('button')}>
              {buttonText}
            </Button>
          </div>
        )}
        {linkText && (
          <div className={cn('link-container')}>
            <button className={cn('link', ['link'])} type="button" onClick={onClickLink}>
              {linkText}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default InfoContent;
